document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeInstantSearchOptions", function (options) {
    // Temporary fix for collection price facet;
    const priceFilterFacetListItem = {
      available_types: ["disjunctive"],
      enabled: true,
      escapedName: "meta.custom.filters.price_filters",
      forgettable: null,
      limit: 99,
      name: "meta.custom.filters.price_filters",
      refined_first: false,
      removeAble: null,
      searchable: false,
      title: "Price",
      type: "disjunctive",
    };
    const list = options.facets.list.map((listItem) => {
      if (listItem.title !== "Price Range") {
        return listItem;
      }

      return {
        ...listItem,
        ...priceFilterFacetListItem,
      };
    });

    const priceFilterFacet = {
      params: {
        operator: "or",
        limit: 99,
        container: "[class~='ais-facet-meta.custom.filters.price_filters-container']",
        attribute: "meta.custom.filters.price_filters",
        templates: {},
        cssClasses: {
          root: "ais-facet",
          header: "ais-facet--header",
          body: "ais-facet--body",
          item: "ais-facet--item",
          label: "ais-facet--label",
          checkbox: "ais-facet--checkbox",
          active: "ais-facet--active",
          count: "ais-facet--count-distinct",
        },
      },
      facet: {
        enabled: true,
        name: "meta.custom.filters.price_filters",
        title: "Price",
        type: "disjunctive",
        available_types: ["menu", "slider", "conjunctive", "disjunctive"],
        forgettable: null,
        searchable: false,
        refined_first: true,
        removeAble: null,
        limit: null,
        escapedName: "meta.custom.filters.price_filters",
      },
    };
    const widgets = options.facets.widgets.map((widget) => {
      if (widget.facet.title !== "Price Range") {
        return widget;
      }
      return {
        ...widget,
        ...priceFilterFacet,
      };
    });

    return {
      ...options,
      facets: {
        ...options.facets,
        list,
        widgets,
      },
    };
  });
});
